<template>
  <div id="paginaImportaTracciatiContabilitaZip">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card File Upload:  -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Scadenziario</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
                <b-col xl="4" md="4" class="pt-1">
                  <ejs-button id="scadenziarioButton" cssClass="e-flat" @click.native="scadenziario()">Scadenziario</ejs-button>
                </b-col>
                <b-col xl="12" md="12" class="pt-1">
                  <ejs-grid
                    id="gridA" ref="gridA"
                    :dataSource="elementiScadenza"
                    :allowSorting="true" :allowFiltering="true"
                    :sortSettings="gridA.sortOptions" :filterSettings="gridA.filterOptions"
                  >
                <e-columns>
                  <e-column field="id" headerText="ID" :isPrimaryKey="true" width="60"></e-column>
                  <e-column field="denominazione" headerText="Denominazione" width="200"></e-column>                  
                  <e-column field="tipo" headerText="Tipologia" width="50"></e-column>
                  <e-column field="descrizione" headerText="Descrizione" width="200"></e-column>
                  <e-column field="dataScadenzaPagamento" headerText="data Pagamento" width="100" :format="settings.formatoData" type="date"></e-column>
                  <e-column field="importo" headerText="Importo" width="50"></e-column>
                </e-columns>
              </ejs-grid>
            </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
 import Vue from 'vue'
 import useJwt from '@/auth/jwt/useJwt'
 import { CardPlugin, DropdownPlugin, LayoutPlugin } from 'bootstrap-vue'
 import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
 import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs'
 import { createElement } from '@syncfusion/ej2-base'
 import {
   GridPlugin,
   ForeignKey,
   Edit as GridEdit,
   Toolbar as GridToolbar,
   Sort as GridSort,
   Filter as GridFilter,
 } from "@syncfusion/ej2-vue-grids";

 // use bootstrap-vue
 Vue.use(CardPlugin)
 Vue.use(DropdownPlugin)
 Vue.use(LayoutPlugin)
 // use Syncfusion
 Vue.use(ButtonPlugin)
 Vue.use(UploaderPlugin)
 Vue.use(GridPlugin);

 const apiVerificaPagamentiUrl = "/demo/api/costoproduzioni/verifica"

 export default {
   data() {
     return {
       d: [],
       elementiScadenza: [],
       settings: {
         formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
         formatoOra: { skeleton: "Hm" },
         //formatoOra: 'HH:mm',
         formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
         formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
         intervalloOra: 5,
         firstDayOfWeek: 1,
       },
       // todo capire ordinamento per data
       gridA: {
         sortOptions: { columns: [{ field: "id", direction: "Ascending" }] },
         filterOptions: { type: "Excel" },
       },
     }
   },
   methods: {
     // per toast
     makeToast(variant = null, title = 'titolo', message = 'messaggio') {
       this.$bvToast.toast(message, {
         title,
         variant,
         solid: true,
         autoHideDelay: 5000,
       })
     },
     scadenziario: function()
     {
       useJwt.post('/demo/api/costoproduzioni/scadenziario', {}).then((r)=>{
         console.log(r.data)
         r.data.forEach((el) => {
           if (el['tipo'] == 'scrittura') {
             el['descrizione'] = el['spettacolo__stagione'] + ' ' + el['spettacolo__titolo']
           }
           if (el['soggetto__tipoSoggetto'] == 'PersonaGiuridica') {
             el['denominazione'] = el['soggetto__ragioneSociale']
           } else {
             el['denominazione'] = el['soggetto__cognome'] + ' ' + el['soggetto__nome']
           }
         })
         this.elementiScadenza = r.data;
       });
     },
     verifica: function(a) {
       let datiDaInviare = {anno: a}
       useJwt.post(apiVerificaPagamentiUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
         let fileName = r.headers["content-disposition"].split("filename=")[1];
         const url = window.URL.createObjectURL(new Blob([r.data]));
         const link = document.createElement("a");
         link.href = url;

         link.setAttribute("download", fileName);
         document.body.appendChild(link);
         link.click();
       }).catch((r) => {
         this.makeToast("primary", "FAILURE", "Errore anno non selezionato")
       });
     }
   },
 }
</script>
<style>
  @import "~@syncfusion/ej2-base/styles/bootstrap.css";
  @import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
  @import "~@syncfusion/ej2-vue-inputs/styles/bootstrap.css";
  @import "~@syncfusion/ej2-grids/styles/bootstrap.css";

  .control-section {
    height: 100%;
    min-height: 200px;
  }

  button:has(> span.prova)
  {
    display: none;
  }
</style>
